// extracted by mini-css-extract-plugin
export default {"root":"LinkedCasesTable_root__i2LKa","linkedCase":"LinkedCasesTable_linkedCase__1-nUb"};